document.addEventListener("DOMContentLoaded", function () {
  // Store references to our event listeners
  const eventListeners = {
    quantityUp: null,
    quantityDown: null,
    quantityInput: null,
    removeItem: null,
    quickAdd: null,
  };

  let isQuickAdding = false;
  let accordionInit = true;

  // Initialize cart drawer
  initializeCartDrawer();

  // Subscribe to cart updates if available
  if (typeof subscribe === "function") {
    subscribe(PUB_SUB_EVENTS.cartUpdate, handleCartUpdate);
    subscribe(PUB_SUB_EVENTS.cartError, handleCartError);
  }

  function initializeCartDrawer() {
    const cartDrawer = document.getElementById("CartDrawer");
    if (!cartDrawer) return;

    // Remove previous listeners if they exist
    if (eventListeners.quantityUp) {
      document.removeEventListener("click", eventListeners.quantityUp);
    }
    if (eventListeners.quantityDown) {
      document.removeEventListener("click", eventListeners.quantityDown);
    }
    if (eventListeners.quantityInput) {
      document.removeEventListener("input", eventListeners.quantityInput);
    }
    if (eventListeners.removeItem) {
      cartDrawer.removeEventListener("click", eventListeners.removeItem);
    }

    // Open Cart triggers (these don't need cleanup as they're on static elements)
    document.querySelectorAll("[data-open-cart]").forEach((button) => {
      button.addEventListener("click", openCartDrawer);
    });

    if (window.initCartUpsellSlider) {
      const slider = cartDrawer.querySelector(".cart-upsell-slider");
      if (slider) {
        slider.dataset.initialized = "false";
        initCartUpsellSlider(slider);
      }
    }

    // Close Cart handler
    document.addEventListener("click", (e) => {
      if (e.target.closest(".cart-drawer__close")) {
        closeCartDrawer();
      }
    });

    // Store and setup new event listeners
    eventListeners.removeItem = (e) => {
      if (e.target.closest("[data-remove-item]")) {
        e.preventDefault();
        handleRemoveItem(e.target.closest("[data-remove-item]"));
      }
    };
    cartDrawer.addEventListener("click", eventListeners.removeItem);

    // Initialize quantity controls with proper debouncing
    initQuantityControls();
    
    // Update button states on initialization
    updateQuantityButtonStates();

    async function initUpsell() {
      const cartResponse = await fetch("/cart.js");
      const cartData = await cartResponse.json();
      filterUpsellProducts(cartData);
    }
    initUpsell();

    const container = document.querySelector(".cart-drawer .custom-accordion");

    if (!accordionInit && container) {
      new CustomAccordion(container);
    }
  }

  async function handleCartUpdate(data) {
    if (data.action === "add") {
      // Update cart count
      const cartResponse = await fetch("/cart.js");
      const cartData = await cartResponse.json();
      await refreshCartContent(cartData);
      openCartDrawer();
    }
  }

  // Global variable to track pending quantity updates
  let pendingQuantityUpdate = null;

  function initQuantityControls() {
    // Remove previous listeners if they exist
    if (eventListeners.quantityUp) {
      document.removeEventListener("click", eventListeners.quantityUp);
    }
    if (eventListeners.quantityDown) {
      document.removeEventListener("click", eventListeners.quantityDown);
    }
    if (eventListeners.quantityInput) {
      document.removeEventListener("input", eventListeners.quantityInput);
    }

    // Quantity up handler
    eventListeners.quantityUp = async (e) => {
      const btn = e.target.closest("[data-quantity-up]");
      if (btn) {
        e.preventDefault();
        if (pendingQuantityUpdate) return;
        pendingQuantityUpdate = true;
        try {
          const input = btn
            .closest(".cart-item")
            .querySelector("[data-quantity-input]");
          input.value = Number(input.value) + 1;
          debouncedQuantityChange(btn, 0);
        } finally {
          pendingQuantityUpdate = false;
        }
      }
    };
    document.addEventListener("click", eventListeners.quantityUp);

    // Quantity down handler
    eventListeners.quantityDown = async (e) => {
      const btn = e.target.closest("[data-quantity-down]");
      if (btn) {
        e.preventDefault();
        if (pendingQuantityUpdate) return;
        const input = btn
          .closest(".cart-item")
          .querySelector("[data-quantity-input]");
        const currentQuantity = Number(input.value) || 1;
        
        // Prevent going below 1
        if (currentQuantity <= 1) {
          return;
        }
        
        pendingQuantityUpdate = true;
        try {
          input.value = currentQuantity - 1;
          // Update button state immediately
          updateQuantityButtonStates();
          debouncedQuantityChange(btn, 0);
        } finally {
          pendingQuantityUpdate = false;
        }
      }
    };
    document.addEventListener("click", eventListeners.quantityDown);

    // Input handler with proper debouncing
    eventListeners.quantityInput = debounce(async (e) => {
      if (e.target.matches("[data-quantity-input]")) {
        const input = e.target;
        const quantityControl = input.closest(".cart-item");
        const maxQuantity = parseInt(quantityControl.dataset.maxQuantity);
        let newQuantity = parseInt(input.value) || 1;

        // Ensure minimum quantity is 1
        if (newQuantity < 1) {
          input.value = 1;
          newQuantity = 1;
          return; // Don't update if below minimum
        }

        if (maxQuantity > 0 && newQuantity > maxQuantity) {
          showStockError(quantityControl, `Only ${maxQuantity} available`);
          input.value = maxQuantity;
          return;
        }

        if (pendingQuantityUpdate) return;
        pendingQuantityUpdate = true;
        try {
          await handleQuantityChange(input, 0);
          // Update button states after input change
          updateQuantityButtonStates();
        } finally {
          pendingQuantityUpdate = false;
        }
      }
    }, 750);
    document.addEventListener("input", eventListeners.quantityInput);
  }

  function showStockError(element, message) {
    // Remove existing error if any
    const existingError = element.querySelector(".stock-error");

    existingError.style.marginTop = "0.5rem";
    existingError.textContent = message;
    // Auto-remove after 3 seconds
    setTimeout(() => {
      existingError.textContent = "";
    }, 3000);
  }

  function updateQuantityButtonStates() {
    const cartDrawer = document.getElementById("CartDrawer");
    if (!cartDrawer) return;

    cartDrawer.querySelectorAll(".cart-item").forEach((item) => {
      const input = item.querySelector("[data-quantity-input]");
      const downButton = item.querySelector("[data-quantity-down]");
      
      if (input && downButton) {
        const quantity = Number(input.value) || 1;
        
        // Disable down button if quantity is 1 or less
        if (quantity <= 1) {
          downButton.disabled = true;
          downButton.style.opacity = "0.5";
          downButton.style.cursor = "not-allowed";
        } else {
          downButton.disabled = false;
          downButton.style.opacity = "1";
          downButton.style.cursor = "pointer";
        }
      }
    });
  }

  function handleCartError(error) {
    console.error("Cart Error:", error);
    // Show error UI
    const errorElement = document.createElement("div");
    errorElement.className = "cart-error";
    errorElement.textContent = error.error || "Cart operation failed";
    document
      .querySelector("#CartDrawer .cart-drawer__content")
      .prepend(errorElement);
    setTimeout(() => errorElement.remove(), 3000);
  }

  // Shared debounced update (600ms after last click)
  const debouncedQuantityChange = debounce(async (element, change) => {
    await handleQuantityChange(element, change);
  }, 600);

  async function handleQuantityChange(element, change) {
    const drawer = element.closest(".cart-drawer__items");
    const quantityControl = element.closest(".cart-item");
    const input = quantityControl.querySelector("[data-quantity-input]");
    const itemKey = quantityControl.dataset.itemId;
    const maxQuantity = parseInt(quantityControl.dataset.maxQuantity);

    // Calculate new quantity
    let newQuantity =
      change === 0 ? parseInt(input.value) || 1 : Number(input.value) + change;

    // Ensure minimum quantity is 1
    if (newQuantity < 1) {
      newQuantity = 1;
      input.value = 1;
      return; // Don't update if already at minimum
    }

    // Validate against stock
    if (maxQuantity > 0 && newQuantity > maxQuantity) {
      showStockError(quantityControl, `Only ${maxQuantity} available`);
      input.value = maxQuantity;
      return;
    }

    // Update UI immediately
    input.value = newQuantity;
    quantityControl.classList.add("updating");
    drawer.classList.add("updating");

    try {
      const response = await fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id: itemKey, quantity: newQuantity }),
      });

      const cartData = await response.json();

      if (typeof publish === "function") {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          action: "update",
          itemKey: itemKey,
          quantity: newQuantity,
          cart: cartData,
        });
      }

      // Only refresh if this is the most recent update
      await refreshCartContent(cartData);
      
      // Update button states after quantity change
      updateQuantityButtonStates();
    } catch (error) {
      if (typeof publish === "function") {
        publish(PUB_SUB_EVENTS.cartError, {
          error: error.message,
          context: "update-quantity",
        });
      }
      // Reset to previous value on error
      input.value = Number(input.value) - change;
      // Update button states on error
      updateQuantityButtonStates();
    } finally {
      quantityControl.classList.remove("updating");
      drawer.classList.remove("updating");
    }
  }

  async function handleRemoveItem(button) {
    const drawer = button.closest(".cart-drawer__items");
    const itemElement = button.closest(".cart-item");
    const itemKey = itemElement.dataset.itemId;

    try {
      button.disabled = true;
      itemElement.classList.add("removing");
      drawer.classList.add("removing");

      const response = await fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({ id: itemKey, quantity: 0 }),
      });

      const cartData = await response.json();

      publish(PUB_SUB_EVENTS.cartUpdate, {
        action: "remove",
        itemKey: itemKey,
        cart: cartData,
      });

      // Always refresh the entire cart content when removing items
      await refreshCartContent(cartData);
    } catch (error) {
      if (typeof publish === "function") {
        publish(PUB_SUB_EVENTS.cartError, {
          error: error.message,
          context: "remove-item",
        });
      }
      button.disabled = false;
      itemElement.classList.remove("removing");
      drawer.classList.remove("removing");
    }
  }

  function filterUpsellProducts(cartData) {
    const upsellItems = document.querySelectorAll(
      ".cart-upsell .product-card-item"
    );
    const cartUpsell = document.querySelector(".cart-upsell");
    if (!upsellItems.length) return;

    const cartIds = cartData.items.map((item) => item.product_id);

    upsellItems.forEach((item) => {
      const productId = item.querySelector(".quick-card-product")?.dataset
        .productId;
      if (productId && cartIds.includes(Number(productId))) {
        item.remove(); // hide product already in cart
      }
    });

    if (
      document.querySelectorAll(".cart-upsell .product-card-item").length === 0
    ) {
      cartUpsell.style.display = "none";
      cartUpsell.style.opacity = "0";
    } else {
      cartUpsell.style.display = "block";
      cartUpsell.style.opacity = "1";
    }

    // Initialize slider if present
    const slider = cartUpsell.querySelector(".upsell-slider");
    if (slider && window.initUpsellSlider) {
      window.initUpsellSlider(slider);
    }
  }

  async function refreshCartContent(cartData) {
    try {
      const cartDrawer = document.getElementById("CartDrawer");
      const cartContent = cartDrawer.querySelector(".cart-drawer__items");
      if (!cartContent) return;

      cartContent.classList.add("loading");

      const localePrefix = window.Shopify?.routes?.root || "";
      const response = await fetch(`${localePrefix}?section_id=cart`);
      if (!response.ok) throw new Error("Failed to fetch cart content");

      const text = await response.text();
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = text;

      // Get the new content from the response - use querySelector instead of getElementById
      const newCartDrawer = tempDiv.querySelector("#CartDrawer");
      if (!newCartDrawer) throw new Error("Cart drawer not found in response");

      // Replace the entire drawer content
      cartDrawer.innerHTML = newCartDrawer.innerHTML;

      // Reinitialize the cart drawer completely
      accordionInit = false;
      initializeCartDrawer();
      filterUpsellProducts(cartData);
      
      // Update quantity button states after refresh
      updateQuantityButtonStates();

      document.querySelectorAll("[data-cart-count]").forEach((el) => {
        cartData.item_count > 0
          ? el.classList.remove("empty")
          : el.classList.add("empty");
        el.textContent = cartData.item_count;
      });

      // Update shipping bar
      if (window.free_shipping_enabled) {
        // updateShippingBar(cartData);
      }
    } catch (error) {
      console.error("Error refreshing cart content:", error);
    } finally {
      const cartContent = document.querySelector(
        "#cart-drawer .cart-drawer__items"
      );
      if (cartContent) cartContent.classList.remove("loading");
    }
  }
});
